import { gql } from 'graphql-request';

const query = gql`
  query myRoyalty {
    me {
      user {
        royalty {
          affilateSalePercent
          rates {
            affilateType
            subscriptionType
            subscriptionDuration
            rate
          }
        }
      }
    }
  }
`;

export default query;
